import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import './prescription_info.css'
import moment from 'moment'
import { calculateAge } from '../../../common_functions'
import { useTranslate } from 'react-polyglot'

const PrescriptionInfo = React.memo(function PrescriptionInfo ({ partialName, date }) {
  const t = useTranslate()
  const { difference, unit } = useMemo(() => calculateAge(date), [date])
  const key = useMemo(() => `ages.${unit}`, [unit])
  const initials = useMemo(() => {
    if (!partialName) return '?'
    const parts = partialName.trim().split(/\s+/)
    const first = parts[0]?.[0] ?? ''
    const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
    return (first + last).toUpperCase()
  }, [partialName])
  return (
    <div className='patient-info-card'>
      <div className='patient-avatar'>{initials}</div>
      <div className='patient-details'>
        <span className='patient-name'>{partialName}</span>
        <span className='patient-meta'>{t(key, difference)} &middot; {moment(date).format('L')}</span>
      </div>
    </div>
  )
})

PrescriptionInfo.propTypes = {
  partialName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired
}

export default PrescriptionInfo
